import React, { useState } from "react";
import { ImageOff } from "lucide-react";
import { absoluteUrl } from "../context/SiteContext";

/**
 * Fills its (relative-positioned) parent. Shows a branded placeholder when the
 * src is empty or fails to load (e.g. an uploaded file that no longer exists).
 */
export default function SmartImage({ src, alt, imgClassName = "" }) {
  const [failed, setFailed] = useState(false);
  const resolved = absoluteUrl(src);
  const showPlaceholder = !resolved || failed;

  if (showPlaceholder) {
    return (
      <div className="absolute inset-0 bg-[#0D1B2A] blueprint-grid flex items-center justify-center" data-testid="image-placeholder">
        <div className="flex flex-col items-center gap-2 text-[#3A506B]">
          <ImageOff className="h-10 w-10" />
          <span className="font-mono text-[9px] tracking-[0.3em] uppercase">Image</span>
        </div>
      </div>
    );
  }

  return (
    <img
      src={resolved}
      alt={alt}
      className={`absolute inset-0 w-full h-full object-cover ${imgClassName}`}
      loading="lazy"
      onError={() => setFailed(true)}
    />
  );
}
